/* DSL Cohort tracking — assign cohort cookie per first-touch month */
(function(){
  var KEY = "dsl_cohort";
  var existing;
  try { existing = localStorage.getItem(KEY); } catch(e){}
  if (existing) return;
  var d = new Date();
  var cohort = d.getFullYear() + "-" + String(d.getMonth()+1).padStart(2,"0");
  try { localStorage.setItem(KEY, cohort); } catch(e){}
  if (window.DSL_AB) window.DSL_AB.track("cohort_assign", {cohort: cohort});
  if (window.dataLayer) window.dataLayer.push({event: "dsl_cohort", cohort: cohort});
})();